import { Link } from "react-router-dom";
import FooterImg from "../assets/img/Claradécor_white.webp";

export default function Footer() {
  return (
    <footer>
      <div className="footer-top">
        <img src={FooterImg} alt="Logo Clara Décors" />
        <div className="footer-links">
          <Link to={"/"}>Accueil</Link>
          <Link to={"/services"}>Services</Link>
          <Link to={"/realisations"}>Réalisations</Link>
          <Link to={"/faq"}>FAQ</Link>
          <Link to={"/contact"}>Contact</Link>
        </div>
      </div>
      <div className="footer-down">
        <div className="footer-down-links">
          <Link to={"/politique-de-confidentialite"}>
            Politique de confidentilité
          </Link>
          <Link to={"/mentions-legales"}>Mentions légales</Link>
        </div>
        <p>© 2025 Clara Décors. Tous droits réservés.</p>
      </div>
    </footer>
  );
}
